import {Grid, Typography} from '@yandex-delivery/blocks'
import clsx from 'clsx'

import {classes} from './ExtraItem.classes'
import type {ExtraItemProps} from './ExtraItem.types'

export function ExtraItem({
  title,
  titleProps,
  titleClassName,
  description,
  descriptionProps,
  descriptionClassName,
  disabled,
  className,
  children,
  onClick,
  clean = false,
}: ExtraItemProps) {
  return (
    <div className={clsx(classes.root, {[classes.pointer]: onClick, [classes.clean]: clean})} onPointerUp={onClick}>
      <Grid
        alignItems="center"
        className={clsx(classes.container, {[classes.disabled]: disabled}, className)}
        container
      >
        <Grid className={classes.lead} direction="column" container item xs>
          <Grid item xs>
            <Typography
              className={titleClassName}
              data-e2e="optimize-route"
              thickness="regular"
              variant="body2"
              {...titleProps}
            >
              {title}
            </Typography>
          </Grid>
          {description && (
            <Grid item xs>
              <Typography className={descriptionClassName} color="minor" variant="caption1" {...descriptionProps}>
                {description}
              </Typography>
            </Grid>
          )}
        </Grid>
        <Grid item>{children}</Grid>
      </Grid>
    </div>
  )
}
